/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMapMinus = createReactComponent("map-minus", "IconMapMinus", [
  ["path", { d: "M12 18.5l-3 -1.5l-6 3v-13l6 -3l6 3l6 -3v11", key: "svg-0" }],
  ["path", { d: "M9 4v13", key: "svg-1" }],
  ["path", { d: "M15 7v8", key: "svg-2" }],
  ["path", { d: "M16 19h6", key: "svg-3" }]
]);

export { IconMapMinus as default };
//# sourceMappingURL=IconMapMinus.js.map
